<template>
  <div class="wallet">
    <my-header :title="currencyDesc"></my-header>
    <div class="infos">
      <div class="total-currency">{{amount}} {{currencyDesc}}</div>
      <div class="dollar">$ {{totalValue}}</div>
      <div class="btns">
        <div class="ui button instagram" @click="goWithdraw">Withdraw</div>
        <div class="ui button instagram" @click="goDeposit">Deposit</div>
      </div>
      <div class="ui buttons">
        <button class="ui button" :class="{active:selectCode=='All'}" @click="tabChange('All')">All</button>
        <button class="ui button" :class="{active:selectCode=='Deposit'}" @click="tabChange('Deposit')">Deposit</button>
        <button class="ui button" :class="{active:selectCode=='Withdraw'}" @click="tabChange('Withdraw')">Withdraw</button>
        <button class="ui button" :class="{active:selectCode=='Transaction'}" @click="tabChange('Transaction')">Transaction</button>
      </div>
      <div class="records">
        <div class="name">Recent {{selectCode}} Records</div>
        <div class="list">
          <div class="item flex between" v-for="(item,index) in showList" :key="index">
            <div class="time">{{item.dateTime | format}}</div>
            <div class="change" v-show="!!item.amount" :class="item.amount>0?'green':'red'">{{item.amount}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader.vue";
import {walletBill} from "../http/api";
import moment from 'moment';
export default {
  components: { MyHeader },
  name: "WalletView",
  data() {
    return {
      name: "BTC",
      currencyCode:"",
      selectCode:"All",
      billList:[],
      amount:"",
      currencyDesc:"",
      totalValue:""
    };
  },
  filters:{
    format(date){
      return moment(date).format("YYYY-MM-DD HH:mm:ss") || ""
    }
  },
  computed:{
    showList(){
      let selectCode = this.selectCode;
      return this.billList.filter(item=>{
        switch (selectCode) {
          case "Transaction":
            return item.type === "transaction"
          case "Deposit":
            return item.type === "deposit"
          case "Withdraw":
            return item.type === "withdraw"
          default:
            return true
        }
      })
    }
  },
  async created() {
    const queryData = this.$route.query;
    this.currencyCode = queryData.currencyCode;
    this.amount = queryData.amount;
    this.currencyDesc = queryData.currencyDesc;
    this.totalValue = queryData.totalValue;
    if(this.currencyDesc){
      this.$loading.show()
      const res = await walletBill({currency:this.currencyDesc})
      if(res){
        this.$loading.hide()
        this.billList = res.data.billList
      }
    }
  },
  methods: {
    tabChange(code){
      this.selectCode = code;
    },
    goWithdraw(){
      this.$router.push({
        path:"/withdraw",
        query:{currency:this.currencyCode}
      })
    },
    goDeposit(){
      this.$router.push("deposit")
    }
  },
};
</script>

<style lang="less" scoped>
.infos {
  text-align: center;
  background-color: #fff;
  overflow: hidden;
  .total-currency {
    font-size: 22px;
    font-weight: bold;
    margin-top: 20px;
  }
  .dollar {
    color: #bbb;
    margin-top: 16px;
  }
  .btns {
    margin-top: 20px;
    margin-bottom: 20px;
    .button {
      margin-right: 20px;
    }
  }
  .buttons{
    width: 100%;
  }
  .records{
    padding: 16px;
    border: 1px solid #eee;
    border-radius: 3px;
    margin: 4px;
    height: calc(100vh - 250px);
    overflow-y: scroll;
    .name{
      text-align: left;
      font-weight: bold;
    }
    .item{
      padding: 10px 5px;
      border-bottom: 1px solid #eee;
      .change{
        &.red{
          color: red;
        }
        &.green{
          color: green;
        }
      }
    }
  }
}
</style>